const baseUrl = '/api/customer/social-notification'

export default {
    list: (opt) => {
        const { type } = opt

        const params = {
            type,
        }
        const qs = Object.keys(params).filter(p => params[p]).map(p => `${p}=${encodeURIComponent(params[p])}`)

        return axios.get(`${baseUrl}${qs && `?${qs}`}`)
    },

    read: (id) => {
        return axios.post(`${baseUrl}/${id}/read`)
    },
}
